import React from 'react';
import { Marker, ViewportProps } from 'react-map-gl';
import { IconButton } from '@material-ui/core';
import PlaceIcon from '@material-ui/icons/Place';
import { MarketData } from '../../types';
import styled from 'styled-components';

interface CustomMarkerProps {
  market: MarketData;
  setSelectedMarket: (nextMarket: MarketData) => void;
  viewport: Partial<ViewportProps>;
  setViewport: (nextViewport: Partial<ViewportProps>) => void;
}

const CustomMarker = ({ market, setSelectedMarket }: CustomMarkerProps) => {
  const validateIsHex = (markerColor: string) => {
    if (/^#[0-9A-F]{6}$/i.test(markerColor)) {
      return markerColor;
    }
    return '#939598';
  };
  return (
    <Marker
      latitude={market.lat}
      longitude={market.long}
      offsetLeft={-32}
      offsetTop={-40}
    >
      <IconButton
        onClick={() => {
          setSelectedMarket(market);
        }}
      >
        <MarkerIcon
          color="primary"
          fontSize="large"
          markercolor={validateIsHex('#FF9B00')}
        />
      </IconButton>
    </Marker>
  );
};

const MarkerIcon = styled(PlaceIcon)<{ markercolor: string }>`
  color: ${(props) => props.markercolor};
`;

export default CustomMarker;
